import { useState } from "react";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { Dialog, IconButton, Switch } from "@mui/material";
import "./NotificationDialog.css";
import "../Components/Components.css";

const NotificationDialog = ({ isOpen, setIsNotificationDialogShown }) => {
  const [isSoundOn, setIsSoundOn] = useState(
    sessionStorage.getItem("isNotificationsMuted") === "true" ? false : true
  );

  const handleClose = () => {
    setIsNotificationDialogShown(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <Dialog
      open={isOpen}
      className="dialog notification-dialog"
      fullWidth
      maxWidth="sm"
      scroll="paper"
      onClose={handleClose}
    >
      <div className="dialog-container">
        <form method="post" onSubmit={handleSubmit}>
          <div className="dialog-content">
            <IconButton className="close-button" onClick={handleClose}>
              <CloseOutlined />
            </IconButton>

            <h2 className="title">Notification</h2>

            <div className="toggle-sound">
              <p>Sound Off</p>

              <Switch
                checked={isSoundOn}
                disabled
                onChange={(event) => {
                  setIsSoundOn(event.target.checked);
                }}
              />

              <p style={{ color: "#727272" }}>Sound On</p>
            </div>
          </div>

          <section className="buttons">
            <button className="cancel" type="button" onClick={handleClose}>
              Cancel
            </button>

            <button
              className="confirm"
              type="submit"
              onClick={() => {
                sessionStorage.setItem(
                  "isNotificationsMuted",
                  isSoundOn ? "false" : "true"
                );

                handleClose();
              }}
            >
              Confirm
            </button>
          </section>
        </form>
      </div>
    </Dialog>
  );
};

export default NotificationDialog;
